module.exports = __webpack_public_path__ + "static/media/invoices.94d88115.svg";